import { palette } from '@centivo/react-components'
import styled from 'styled-components'

export const StyledResultsPage = styled.div`
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 auto;
  width: 100%;
  max-width: 1440px;
  min-height: 100vh;
  padding: 0.5rem 2.5rem 2.5rem;

  input[type='radio'],
  input[type='checkbox'] {
    margin: 0 0.25rem;
  }

  h3 button {
    font-weight: 700;
  }

  button[role='switch'] span::before {
    box-sizing: content-box;
  }
`

export const StyledSearchLanding = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 3rem 1.5rem;
  background: #ffffff;
  min-height: 100vh;

  h2 {
    margin: 0;
    font-family: 'roc-grotesk', 'Space Grotesk', system-ui, sans-serif;
  }

  p {
    margin: 0;
    max-width: 35rem;
    text-align: center;
    color: ${palette.brand.gray};
    font-family: 'roc-grotesk', 'Space Grotesk', system-ui, sans-serif;
  }
`
